import { SeahorseRoute } from '@seahorse/common';
import { LoginPage } from './login/login.page';
import { loginGuard } from '@seahorse/auth';
import {
  ActivateAccountComponent,
  RegisterAccountThankYouComponent,
} from '@seahorse/ui';
import { InvitationComponent } from './Invitation/invitation.component';
import { ForgotPasswordPage } from './forgot-password/forgot-password.page';
import { ResetPasswordPage } from './reset-password/reset-password-page';

export const authRoutes: SeahorseRoute[] = [
  {
    path: 'account',
    children: [
      {
        path: 'login',
        component: LoginPage,
        canActivate: [loginGuard],
      },
      {
        path: 'forgot-password',
        component: ForgotPasswordPage,
      },
      {
        path: 'reset-password',
        component: ResetPasswordPage,
      },
      {
        path: 'invite',
        component: InvitationComponent,
      },
      {
        path: 'register/thank-you',
        component: RegisterAccountThankYouComponent,
        canActivate: [loginGuard],
      },
      {
        path: 'activate',
        component: ActivateAccountComponent,
        canActivate: [loginGuard],
      },
    ],
  },
];
